'use client';

import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { FaCheck } from 'react-icons/fa';

import styles from './button-like-radio.component.module.scss';

/*
  ButtonLikeRadioとCheckbuttonはほぼ同じ実装で違いはinputのtypeのみ
*/
export const ButtonLikeRadio = forwardRef<
  HTMLInputElement,
  Omit<ComponentPropsWithoutRef<'input'>, 'type'>
>(({ children, value, ...props }, forwardedRef) => {
  return (
    <label className={styles.radio}>
      <input {...props} ref={forwardedRef} type="radio" value={value} />
      <span className={styles.radioView}>
        <span className={styles.iconBox}>
          <FaCheck aria-hidden="true" />
        </span>
        <span>{children}</span>
      </span>
    </label>
  );
});
ButtonLikeRadio.displayName = 'ButtonLikeRadio';
